// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3kvsn","unreadBadge":"styles_unreadBadge__8AKlx","modalContent":"styles_modalContent__2ZtKe","modal":"styles_modal__t1U6G"};